import { render, staticRenderFns } from "./MortgageApplications.vue?vue&type=template&id=38564a07"
import script from "./MortgageApplications.vue?vue&type=script&lang=js"
export * from "./MortgageApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports